import reducer, { actions, selectors, STATE_KEY } from './modules/slice';
import saga from './modules/saga';
import soundSaga from './modules/soundSaga';

export { saga, soundSaga, reducer, actions, selectors };
export const alertsStateKey = STATE_KEY;
